export default __webpack_public_path__ + "static/media/17.d1d66049.JPG";